export default "__VITE_ASSET__BqocZzZM__"